import React, { useEffect, useState } from "react"
import { useAppDispatch } from "../../../store"
import { setCurrentPage } from "../../../store/auth/authReducer"
import { Navigate, useLocation } from "react-router-dom"
import axios from "axios"
import Box from "@mui/material/Box"
import TextField from "@mui/material/TextField"
import Button from "@mui/material/Button"
import Snackbar from "@mui/material/Snackbar"
import Alert from "@mui/material/Alert"
import Select from "@mui/material/Select"
import MenuItem from "@mui/material/MenuItem"
import FormControl from "@mui/material/FormControl"
import InputLabel from "@mui/material/InputLabel"
import { useSelector } from "react-redux"
import { logOut } from "../../../utils/logOut"
import { Switch, Typography } from "@mui/material"
import { ExportData, ImportData } from "../../../utils/LanguageTableHelper"
import LanguageTable from "../../../components/Table/LanguageTable"
import TranslatedText from "../../../utils/Translate"
import { useSnackbar } from "../../../utils/SnackbarContext"

export default function WordGroup() {
    const dispatch = useAppDispatch()
    const location = useLocation()
    const [openSnackbar, setOpenSnackbar] = useState(false)
    const [snackbarType, setSnackbarType] = useState("")
    const [partners, setSPartners] = useState([])
    const [conversationtemplates, setConversationtemplates] = useState([])

    //Get params from URL
    const params = new URLSearchParams(location.search);
    const id = params.get('id');
    const type: string | null = params.get('type')

    //Get access level
    const accesslevel = useSelector(
        (state: any) => state.auth.authData.accesslevel
    )

    const { showSnackbar } = useSnackbar();

    //Switch header title

    useEffect(() => {
        dispatch(setCurrentPage(type === "edit" ? `Edit Word Group` : 'Add Word Group'))
    }, [dispatch]);


    //Handle close snackbar
    const handleClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnackbar(false);
    };

    //Get word group
    async function fetchData(params: object = {}) {
        try {
            const response = await axios.get(`https://cardgarantsales.com/restapi/wordgroup/${id}`, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                }, params: params
            })

            if (response.data !== null) {
                if (typeof (response.data) === 'object') {
                    setWordGroupData({
                        ...response.data[0],
                        groupdetails: ImportData(JSON.parse(response.data[0].groupdetails))
                    })
                }
                else showSnackbar('ERROR: INVALID SERVER RESPONSE', 'error')
            }

            console.log(response.data[0]);

        } catch (error: any) {
            console.log(error);
            if (error.code === "ERR_BAD_REQUEST") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }

    //Create contact group
    async function postData(data: any = {}) {
        try {
            const response = await axios.post(`https://cardgarantsales.com/restapi/wordgroup`, {
                ...data,
                groupdetails: JSON.stringify(ExportData(data.groupdetails))
            }, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                },
            })

            setSnackbarType('success')
            setOpenSnackbar(true)
        } catch (error: any) {
            setSnackbarType('error')
            setOpenSnackbar(true)
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }

    //Edit contact group
    async function putData(data: any = {}) {
        try {
            const response = await axios.put(`https://cardgarantsales.com/restapi/wordgroup/${id}`, {
                ...data,
                groupdetails: JSON.stringify(ExportData(data.groupdetails))
            }, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                },
            })

            setSnackbarType('success')
            setOpenSnackbar(true)
        } catch (error: any) {
            setSnackbarType('error')
            setOpenSnackbar(true)
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }

    const [wordGroupData, setWordGroupData] = useState<any>(type === 'edit' ? [] :
        {
            "id": null,
            "code": null,
            "name": null,
            "groupdetails": ImportData([]),
            "partner": "0",
            "showsetuptopartner": "0",
            "conversationtemplate": null,
            "partnerbankcode": null,
            "conversationtemplatecode": null
        }
    )

    //Get partners for Select field
    async function getPartners(params: object = {}) {
        try {
            const response = await axios.get(`https://cardgarantsales.com/restapi/partner`, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                }, params: params
            })
            console.log(response.data);
            if (response.data !== null) {
                if (typeof (response.data) === 'object') {
                    setSPartners(response.data)
                }
                else showSnackbar('ERROR: INVALID SERVER RESPONSE', 'error')
            }
        } catch (error: any) {
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }

    async function getConversationtemplates(params: object = {}) {
        try {
            const response = await axios.get(`https://cardgarantsales.com/restapi/conversationtemplate`, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                }, params: params
            })
            console.log(response.data);
            setConversationtemplates(response.data)
        } catch (error: any) {
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }


    //On load if URL params contains type=edit - get contactgroup data, if accesslevel = 5 - get partners for Select field
    useEffect(() => {
        type === 'edit' && fetchData()
        getPartners()
        getConversationtemplates()
        console.log(wordGroupData);

    }, [type])


    return (
        <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
            <Box>
                <Box sx={{ display: "flex", mb: 2, flexWrap: "wrap", width: '100%', justifyContent: 'space-between', gap: 2 }}>
                    <TextField error={wordGroupData.code === null} onChange={(e) => setWordGroupData({ ...wordGroupData, code: e.target.value !== '' ? e.target.value : null })} value={wordGroupData.code || ''} variant="outlined" size="small" label={<TranslatedText text={'Code*'} />} />
                    <TextField onChange={(e) => setWordGroupData({ ...wordGroupData, name: e.target.value !== '' ? e.target.value : null })} value={wordGroupData.name || ''} variant="outlined" size="small" label={<TranslatedText text={'Name'} />} />
                    <FormControl>
                        <InputLabel size="small" id="simple-select-label"><TranslatedText text={'Conversation template'} /></InputLabel>
                        <Select sx={{ width: 223 }} labelId="simple-select-label" onChange={(e) => setWordGroupData({ ...wordGroupData, conversationtemplate: e.target.value !== '' ? e.target.value : null })} value={wordGroupData.conversationtemplate || ''} variant="outlined" size="small" label={<TranslatedText text={'Conversation template'} />} >
                            <MenuItem value={''}><TranslatedText text={'General'} /></MenuItem>
                            {
                                conversationtemplates.map((el: any) => {
                                    //make conversationtemplate list item
                                    return (
                                        <MenuItem key={el.id} value={el.id}>{el.conversationtemplatecode}</MenuItem>
                                    )
                                })
                            }
                        </Select>
                    </FormControl>
                    {accesslevel === '5' &&
                        <>
                            <FormControl>
                                <InputLabel size="small" id="simple-select-label"><TranslatedText text={'Owner'} /></InputLabel>
                                <Select sx={{ width: 223 }} labelId="simple-select-label" value={wordGroupData.partner || ''} onChange={(e) => setWordGroupData({ ...wordGroupData, partner: e.target.value })} variant="outlined" size="small" label={<TranslatedText text={'Owner'} />} >
                                    <MenuItem value={''}><TranslatedText text={'System owner'} /></MenuItem>
                                    <MenuItem value={'0'}><TranslatedText text={'General and private'} /></MenuItem>
                                    {
                                        partners.map((el: any) => {
                                            return (
                                                <MenuItem key={el.id} value={el.id}>{el.partnerbankcode}</MenuItem>
                                            )
                                        })
                                    }
                                </Select>
                            </FormControl>
                            <Box sx={{ display: "flex", alignItems: "center", width: 223, pl: 2 }}>
                                <Typography><TranslatedText text={'Allow editing'} /></Typography>
                                <Switch onChange={(e) => setWordGroupData({ ...wordGroupData, showsetuptopartner: wordGroupData.showsetuptopartner === '0' ? '1' : '0' })} checked={Boolean(+wordGroupData.showsetuptopartner)} />
                            </Box>
                        </>
                    }


                </Box>
                <Box sx={{ width: '90vw', overflow: 'auto', mb: 3 }}>
                    <LanguageTable setTableData={(e: any) => setWordGroupData({ ...wordGroupData, groupdetails: e })} tableData={wordGroupData.groupdetails !== undefined ? wordGroupData.groupdetails : ImportData([])} />
                </Box>
                <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                    <Button onClick={() => type === "edit" ? putData(wordGroupData) : postData(wordGroupData)} variant="contained" sx={{ width: "100%" }}><TranslatedText text={'Save'} /></Button>
                </Box>

            </Box>
            {type !== 'edit' && snackbarType === 'success' && <Navigate to='/wordgroups' />}
            <Snackbar open={openSnackbar} autoHideDuration={6000} onClose={handleClose}>
                {snackbarType === 'error' ?
                    <Alert onClose={handleClose} severity="error" sx={{ width: '100%' }}>
                        <TranslatedText text={'Saving error'} />
                    </Alert> :
                    <Alert onClose={handleClose} severity="success" sx={{ width: '100%' }}>
                        <TranslatedText text={'Successfully saved'} />
                    </Alert>}
            </Snackbar>
        </Box >
    )
}